export const getMultipleOptionsValue = (options, internalValue) => options.reduce((acc, option) => {
  if (option.options) {
    return acc.concat(getMultipleOptionsValue(option.options, internalValue));
  } else {
    if (internalValue.includes(option.value)) {
      return acc.concat(option);
    }
    return acc;
  }
}, []);
export const getSingleOptionsValue = (options, internalValue) => {
  for (let i = 0; i < options.length; i++) {
    if (options[i].options) {
      const value = getSingleOptionsValue(options[i].options, internalValue);
      if (value) {
        return value;
      }
    } else {
      if (options[i].value === internalValue) {
        return options[i];
      }
    }
  }
};
export const getOptionsValue = (options, internalValue, multiple) => {
  if (!multiple) {
    // Looking for a single value
    return getSingleOptionsValue(options, internalValue);
  } else {
    // Looking for multiple values
    return getMultipleOptionsValue(options, internalValue);
  }
};
export const getValue = (options, internalValue, multiple, useNativeSelect) => {
  if (useNativeSelect) {
    return internalValue;
  }
  return getOptionsValue(options, internalValue, multiple);
};